import React from 'react'
import { Wrapper, Text } from './index.styled'

const Footer = () => {
  return (
    <Wrapper>
      <Text>Copyright © 2025 MD Anderson. All rights reserved.</Text>
    </Wrapper>
  )
}

export default Footer;